import _ from "lodash";

import { mapState } from "vuex";
import EventsCard from "@/components/Events/Cards/Event";
import Event from "@/services/Event";

import getCurrentSeason from "@/helpers/events/getCurrentSeason";
import getPossibleSeasons from "@/helpers/events/getPossibleSeasons";
import getPossibleStages from "@/helpers/events/getPossibleStages";

export default {
  name: "Admin",

  components: {
    EventsCard,
  },

  data: () => ({
    loadingEvents: false,

    events: [],

    selectedSeason: null,
  }),

  created() {
    this.selectedSeason = getCurrentSeason(this.community);
  },

  computed: {
    ...mapState(["isJudge", "community"]),

    possibleSeasons() {
      return getPossibleSeasons(this.community);
    },

    tournamentStages() {
      return _.map(getPossibleStages(this.community), "kind");
    },

    season() {
      return (
        (this.selectedSeason && this.selectedSeason._id) ||
        getCurrentSeason(this.community)
      );
    },
  },

  watch: {
    season() {
      this.fetchEvents();
    },
  },

  methods: {
    editEvent(event) {
      this.$router.push({
        name: "admin.event",
        params: { id: event._id },
      });
    },

    fetchEvents() {
      this.loadingEvents = true;

      const query = { "event.kind": this.tournamentStages };

      if (this.selectedSeason && this.selectedSeason._id) {
        query["event.season"] = this.selectedSeason._id;
      }

      Event.list(query).then(
        (res) => {
          this.loadingEvents = false;
          this.events = res.data;
        },
        () => {
          this.loadingEvents = false;
        },
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/Admin/Admin.js